import type { OAuthStore } from './interfaces'

export const actions = {
  setLoading (this: OAuthStore, payload: OAuthStore['loading']): void {
    this.loading = payload
  },
  setGoogle (this: OAuthStore, payload: OAuthStore['google']): void {
    this.google = payload
  },
  setZoho (this: OAuthStore, payload: OAuthStore['zoho']): void {
    this.zoho = payload
  },
}
